export const PUSH_SINGLE_ROUTER = 'pushSingleRouter';
export const REFRESH_AUTOMATION_RULE_LIST = 'refreshAutomationRuleList'; // 刷新自动化规则列表

export const RESET_AUTOMATION_RULE_LIST = 'resetAutomationRuleList'; // 重置自动化规则列表

export const SYNC_SERVER_TIME = 'syncServerTime';

export const REFRESH_SAAS_TICKET_TAGS = 'refreshSaasTicketTags'; // 刷新SaaS工单标签
export const REFRESH_EMAIL_TICKET_TAGS = 'refreshEmailTicketTags'; // 刷新邮件工单标签
